var app = angular.module('leonardo');

var ReportTypeFilter = function (ReportService) {
  return function (report_type) {
    var name = 'Invalid type';
    angular.forEach(ReportService.TYPE_OPTIONS, function(type) {
      if (report_type == type.id)
        name = type.name;
    });
    return name;
  }
};

app.filter('reportType', ['ReportService', ReportTypeFilter]);
